import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";
import {LoaderService} from "./loader.service";
import {EnvironmentService} from "./environment.service";
import {ActionResult, ActionResultList, ApplicationFormSettings} from "@model";

@Injectable({providedIn: 'root'})
export class ApplicationFormSettingsService {
  constructor(private http: HttpClient, private loaderService: LoaderService, private environmentService: EnvironmentService) {
  }

  fetchApplicationFormSettings(raceId: number | undefined): Observable<ApplicationFormSettings | null> {
    return this.http.post<ActionResult<ApplicationFormSettings>>(this.environmentService.getApiUrl() + "/api/public/applicationformsettings/getbyraceid", raceId)
      .pipe(map((value: ActionResult<ApplicationFormSettings>) => value?.result ?? null)
      );
  }

  fetchApplicationFormSettingsByEventId(eventId: number | undefined): Observable<ApplicationFormSettings[]> {
    return this.http.get<ActionResultList<ApplicationFormSettings[], number>>(this.environmentService.getApiUrl() +
      `/api/public/applicationformsettings/getbyeventid?eventId=${eventId}`).pipe(
      map((value: ActionResultList<ApplicationFormSettings[], number>) => {
        return value?.result ?? [];
      })
    );
  }

  updateApplicationFormSettings(formSettings: ApplicationFormSettings, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/applicationformsettings/update", formSettings)
      .subscribe((actionResult: ActionResult<boolean>) => {
        actionResult.resultCode !== -1 ? onSuccess() : onError();
      });
  }
}
